<template>
  <div>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.privacy-section-3
        class="text-left fw-500 d-flex align-items-center justify-content-between">
            <div>
                <span class="box-numbering">03</span>
                <span>How We Use Your Information We use the information we collect</span>    
            </div>
            <span 
                class="toggle-icon" 
                :class="{ active: isOpen }"
            >
                <span class="plus">+</span>
                <span class="cross">×</span>
            </span> 
        </b-button>
      </b-card-header>
      <b-collapse
        id="privacy-section-3"
        visible
        accordion="my-accordion"
        role="tabpanel"
        @show="isOpen = true"
        @hide="isOpen = false"
      >
        <b-card-body>
          <p class="text-justify">
            <ol>
                <li>To provide, maintain, and improve {{ companyName }} card solutions and related services.</li>
                <li>To verify your identity and comply with legal obligations, such as anti-money laundering (AML) and Know Your Customer (KYC) regulations.</li>
                <li>To process transactions and manage your account.</li>
                <li>To communicate with you about your account, services, and updates.</li>
                <li>To detect, prevent, and address fraud, unauthorized transactions, and other security issues.</li>
            </ol>
          </p>
          <p class="text-justify">
            For internal business purposes such as audits, data analysis, and research.
            </p>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "section-3",
  data() {
    return {
      publicPath: process.env.BASE_URL != "/" ? process.env.BASE_URL : "",
      isOpen: true
    };
  },
  props:['companyName']
};
</script>
